import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

const Seo = ({ title='', description='' }) => {

  const { t } = useTranslation()

  const getSeoTitle = (newTitle) => {
    if (!newTitle) return t('seoDefaultTitle')

    const isTooLong = newTitle.length > 55
    const seoTitle = isTooLong 
      ? `${newTitle.slice(0, 52)}...`
      : newTitle
    
    return `${seoTitle} | Flixxo`
  }

  const getSeoDescription = (newDescription) => {
    if (!newDescription) return t('seoDefaultDescription')

    const isTooLong = newDescription.length > 117
    const seoDescription = isTooLong 
      ? `${newDescription.slice(0, 114)}...`
      : newDescription
    
    return seoDescription
  }
  
  
  const seoTitle = getSeoTitle(title)
  const seoDescription = getSeoDescription(description)

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
    </Helmet>
  )
}

export default Seo